import { render, staticRenderFns } from "./WsTestBtn.vue?vue&type=template&id=1b258b3e&"
import script from "./WsTestBtn.vue?vue&type=script&lang=js&"
export * from "./WsTestBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports